import { render, staticRenderFns } from "./questionTypeSetting.vue?vue&type=template&id=2f7ee692&scoped=true&"
import script from "./questionTypeSetting.vue?vue&type=script&lang=js&"
export * from "./questionTypeSetting.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeSetting.vue?vue&type=style&index=0&id=2f7ee692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ee692",
  null
  
)

export default component.exports